import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    this._handleOutsideClick = this._handleOutsideClick.bind(this)
  }

  toggle() {
    const open = !this.menuTarget.hidden
    this.menuTarget.hidden = open
    if (!open) {
      document.addEventListener("click", this._handleOutsideClick, { once: true })
    }
  }

  close() {
    this.menuTarget.hidden = true
  }

  _handleOutsideClick(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this._handleOutsideClick)
  }
}
